export default function initSlider() {
    let slider = document.querySelectorAll(".slider");
    const AUTOPLAY_SPEED = 5000;

    slider.forEach((slider) => {
        let images = slider.querySelectorAll(".image");
        let activeIndex = 0;
        let autoplay = null;
        let indicators = slider.querySelectorAll(".indicator");

        window.libs.ScrollTrigger.create({
            trigger: slider,
            start: "top bottom",
            end: "bottom top",
            onEnter: () => {
                indicators[activeIndex].classList.remove("active");
                startAutoplay()
                setTimeout(() => {
                    indicators[activeIndex].classList.add("active");
                }, 1)
            },
            onEnterBack: () => {
                indicators[activeIndex].classList.remove("active");
                startAutoplay()
                setTimeout(() => {
                    indicators[activeIndex].classList.add("active");
                }, 1)
            },
            onLeave: () => {
                stopAutoplay()
            },
            onLeaveBack: () => {
                stopAutoplay()
            },
        });

        setSlide(activeIndex);

        function startAutoplay() {
            autoplay = setInterval(function() {
                nextSlide();
            }, AUTOPLAY_SPEED);
        }

        function stopAutoplay() {
            clearInterval(autoplay);
            autoplay = null;
        }

        function resetAutoplay() {
            stopAutoplay();
            startAutoplay();
        }

        function nextSlide() {
            let index = activeIndex;
            if(index < images.length - 1) {
                index++;
            } else {
                index = 0;
            }
            setSlide(index);
        }

        indicators.forEach((indicator, index) => {
            indicator.addEventListener("click", () => {
                setSlide(index);
            });
        });

        function setSlide(index) {
            images[activeIndex].classList.remove("active");
            images[index].classList.add("active");
            indicators[activeIndex].classList.remove("active");
            indicators[index].classList.add("active");
            activeIndex = index;

            if(autoplay !== null) {
                resetAutoplay();
            }
        }
    });
}